<template>
  <v-container>
    <v-card>
      <v-card-title>
        Feriados
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="4">
            <v-menu
              v-model="datePickerOpen"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="newDate"
                  label="Fecha"
                  readonly
                  v-on="on"
                  class="cursor-pointer"
                />
              </template>
              <v-date-picker
                v-model="newDate"
                locale="es-AR"
                @input="datePickerOpen = false"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" md="5">
            <v-text-field v-model="newName" label="Descripción" />
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
              class="primary"
              :disabled="!newDate || !newName || saving"
              @click="add"
            >Agregar</v-btn>
          </v-col>
        </v-row>

        <v-alert v-if="errorMessage" type="error" dense text>{{ errorMessage }}</v-alert>

        <v-data-table
          :headers="headers"
          :items="holidays"
          :loading="loading"
          no-data-text="No hay feriados cargados"
          :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn icon :disabled="saving" @click="remove(item)">
              <v-icon color="error">delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import holidaysService from "@/services/HolidaysService";

export default {
  name: "list-holidays",
  data() {
    return {
      holidays: [],
      loading: false,
      saving: false,
      datePickerOpen: false,
      newDate: null,
      newName: null,
      errorMessage: null,
      headers: [
        { text: "Fecha", value: "date" },
        { text: "Descripción", value: "name" },
        { text: "Acciones", value: "actions", sortable: false, width: 100 }
      ]
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.errorMessage = null;
      this.loading = true;
      try {
        this.holidays = await holidaysService.list();
      } catch (error) {
        this.errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          "No se pudieron cargar los feriados";
      } finally {
        this.loading = false;
      }
    },
    async add() {
      this.errorMessage = null;
      this.saving = true;
      try {
        await holidaysService.create({ date: this.newDate, name: this.newName });
        this.newDate = null;
        this.newName = null;
        await this.load();
      } catch (error) {
        this.errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          "No se pudo agregar el feriado";
      } finally {
        this.saving = false;
      }
    },
    async remove(item) {
      this.errorMessage = null;
      this.saving = true;
      try {
        await holidaysService.remove(item._id);
        await this.load();
      } catch (error) {
        this.errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          "No se pudo borrar el feriado";
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.cursor-pointer >>> input {
  cursor: pointer;
}
</style>
